module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"description":"QR Scanner","cancel":"Abbrechen"},"en":{"description":"QR Scanner","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
